<script lang="ts">
  import { getContext, type Snippet } from "svelte";
  import { melt, createDropdownMenu } from "@melt-ui/svelte";

  interface Props {
    rightSlot?: string;
    onSelect?: () => void;
    href?: string;
    children?: Snippet;
    class?: string;
  }

  let { rightSlot, onSelect, href, children, class: className }: Props = $props();

  const menu = getContext<ReturnType<typeof createDropdownMenu>>("menu");
  const { item } = menu.elements;

  const classes = $derived([
    className,
    "w-full cursor-pointer truncate rounded-xl px-2 py-1.5 text-mono-000 select-none data-highlighted:bg-alpha-200 data-highlighted:outline-hidden dark:text-mono-900",
  ]);
</script>

{#if href}
  <a
    {href}
    class={[...classes, "block text-inherit no-underline"]}
    {...$item} use:$item.action
    onclick={(e) => {
      if (!e.ctrlKey && !e.metaKey && onSelect) {
        e.preventDefault();
        onSelect();
      }
    }}
  >
    {@render children?.()}
    {#if rightSlot}
      <span class="right-slot">{rightSlot}</span>
    {/if}
  </a>
{:else}
  <div class={classes} {...$item} use:$item.action onclick={onSelect}>
    {@render children?.()}
    {#if rightSlot}
      <span class="right-slot">{rightSlot}</span>
    {/if}
  </div>
{/if}
